import { render } from "./ExamsList.vue?vue&type=template&id=fd6ebc3c&ts=true"
import script from "./ExamsList.vue?vue&type=script&lang=ts"
export * from "./ExamsList.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__